import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { useFormikGoodFilters } from '../../../../utils';
import { DirectGoodsFilter } from '../../types';
import { useEntryStates, useSupervisors } from '../../../../share';
import DirectGoodsDetailContainer from './DirectGoodsDetailContainer';
import { useFetchDirectGoodsRequests } from '../../../../hooks';
import DirectGoodsView from '../Views/DirectGoodsView';
import { useAtom } from 'jotai';
import { authAtom } from '../../../../state';

const handlePagination = (
  page: number,
  setFilter: React.Dispatch<React.SetStateAction<DirectGoodsFilter>>
) => {
  setFilter({
    page: page.toString(),
  });
};

const DirectGoodsContainer: React.FC = () => {
  const { data: entryStates } = useEntryStates();
  const { data: supervisors } = useSupervisors();
  const [modalDetail, setmodalDetail] = useState(false);
  const [authData] = useAtom(authAtom);
  const [filter, setFilter] = useState<DirectGoodsFilter>({});

  const {
    data: goods,
    isPending: loadList,
    refetch,
  } = useFetchDirectGoodsRequests(filter || {});
  const [itemSelected, setItemSelected] = useState<any>();

  const formik = useFormikGoodFilters({
    onSubmit: (values) => handleFilter(values, authData, setFilter),
  });

  const handleFilter = useCallback(
    async (
      values: Partial<DirectGoodsFilter>,
      authData: any,
      setFilter: React.Dispatch<React.SetStateAction<DirectGoodsFilter>>
    ) => {
      setFilter({
        ...values,
        created_at: values.created_at
          ? new Date(values.created_at).toISOString().split('T')[0]
          : '',
      });
    },
    []
  );

  useEffect(() => {
    refetch();
  }, [filter, refetch]);

  return (
    <Fragment>
      {modalDetail && (
        <DirectGoodsDetailContainer
          isOpen={modalDetail}
          OnClose={() => {
            setmodalDetail(false);
            formik.resetForm();
          }}
          data={itemSelected}
          refetch={refetch}
        />
      )}
      <DirectGoodsView
        isLoading={loadList}
        data={goods}
        supervisors={supervisors}
        states={entryStates}
        formik={formik}
        onViewDetail={(item: any) => {
          setmodalDetail(true);
          setItemSelected(item);
        }}
        onPagination={(page) => handlePagination(page, setFilter)}
        onResetFilters={() => {
          handleFilter({}, authData, setFilter);
          formik.resetForm();
        }}
      />
    </Fragment>
  );
};

export default DirectGoodsContainer;
